import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';

const KEY = ['pricing', 'rules'];

export function useRules() {
  return useQuery({
    queryKey: KEY,
    queryFn: async () => {
      const { data } = await api.get('/pricing/rules');
      return data?.rules || data?.data || data || [];
    },
    staleTime: 30_000
  });
}

export function useCreateRule() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (body) => api.post('/pricing/rules', body).then((r) => r.data),
    successMessage: 'تم إنشاء القاعدة',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}

export function useUpdateRule() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: ({ id, body }) => api.patch(`/pricing/rules/${id}`, body).then((r) => r.data),
    successMessage: 'تم حفظ التعديلات',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}

export function useDeleteRule() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (id) => api.delete(`/pricing/rules/${id}`).then((r) => r.data),
    successMessage: 'تم حذف القاعدة',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}

export function useSetDefaultRule() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (id) => api.post(`/pricing/rules/${id}/set-default`).then((r) => r.data),
    successMessage: 'تم تعيين القاعدة الافتراضية',
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY })
  });
}
